import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { Adsense } from "@ctrl/react-adsense";
import { isMobile } from "react-device-detect";

import { setGame } from "stores/game/GameSlice";
import { getSimulationGame } from "interfaces/game";
import { AdsenseAccount } from "constants/config";
import { showAds } from "utils/ads";
import { RootState } from "stores/Store";
import { setShowNavbar, setShowFriends } from "../stores/uiState/UiStateSlice";

function Lab() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state: RootState) => state.userReducer.user);

  useEffect(() => {
    dispatch(setShowNavbar(true));
    dispatch(setShowFriends(true));
  }, []);

  return (
    <div className="GameModeSelection">
      <div className="topWrapper">
        <div className="heroContainer">
          <h1 className="title">Drafting Lab</h1>
          <h2 className="headline">Your workshop for draft mastery</h2>
        </div>
        <div className="GameModeCard">
          <motion.button
            className="joinGameButton"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            onClick={() => {
              dispatch(setGame(getSimulationGame()));
              navigate("/game");
            }}
          >
            Solo Training
          </motion.button>
          <div>
            The place to try new things! Craft new drafts by playing both red
            and blue sides solo.
          </div>
        </div>
        {showAds(user) && (
          <Adsense
            client={AdsenseAccount}
            slot={isMobile ? "5279432204" : "9863584592"}
            style={{
              display: "inline-block",
              marginTop: "2em",
              width: isMobile ? "300px" : "100%",
              height: "100px",
            }}
            format={isMobile ? "" : "rectangle"}
          />
        )}
      </div>
    </div>
  );
}

export default Lab;
